<div [hidden]="selectedTransaction !== undefined">
  <h4>Transactions eligible for refund</h4>

  <app-filterable-table
    #transactionTable
    [tableView]="tableView"
    (initialized)="handleTableInitialized()"
    (selectedRecord)="handleRecordSelected($event)"
  ></app-filterable-table>
</div>

<div [hidden]="selectedTransaction == undefined">
  <div>
    Customer: {{ selectedTransaction?.customerFirstName }}
    {{ selectedTransaction?.customerLastName }}
  </div>
  <div>Date: {{ selectedTransaction?.date }}</div>
  <div>Settled: {{ settledDate }}</div>
  <div>Type: {{ selectedTransaction?.type }}</div>
  <div>{{ formattedAmount }}</div>
  <div [innerHTML]="formattedCard | safeHtml: 'html'"></div>

  <div>
    <input
      type="button"
      value="Select a different transaction"
      (click)="btnChangeTransaction_clicked()"
    />
  </div>
</div>
